(() => {
  if (customElements.get('wera-product-rating')) return;
  customElements.define('wera-product-rating', class extends HTMLElement {
    connectedCallback() {
      this.navigate = (event) => {
        if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
        const target = document.getElementById('judgeme_product_reviews');
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        target.focus({ preventScroll: true });
        target.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      };
      this.addEventListener('click', this.navigate, true);
      this.addEventListener('keydown', this.navigate, true);
    }
    disconnectedCallback() {
      this.removeEventListener('click', this.navigate, true);
      this.removeEventListener('keydown', this.navigate, true);
    }
  });
})();
